import { DescriptionParams } from '../localeParams'

const cmdsJA: DescriptionParams = {
  description: '💎 ソラナバリデーターオールインワン CLI ツール 💎',
  version: '現在のバージョンを出力',
  help: 'solv コマンドのオプション詳細を表示',
  subcmdHelp: 'サブコマンドのヘルプを表示',
  server: 'solv ダッシュボードを開く',
  start: 'ノードを起動',
  stop: 'ノードを停止',
  status: 'ノードのステータスを表示',
  restart: 'ノードを再起動',
  update: 'ノードのバージョンを更新',
  get: 'ノードの設定情報を取得 サブコマンド',
  log: 'ノードのログを表示',
  catchup: 'ノードをキャッチアップ',
  monitor: 'ノードを監視',
  config: 'ノードの設定を表示',
  install: 'ソラナのバージョンを更新/インストール',
  stake: 'ソラナのステーキングを行う',
  unstake: 'ソラナのアンステーキングを行う',
  check: 'ノードの状態をチェック',
  scp: 'scp サブコマンド',
  cron: 'スケジュールタスク サブコマンド',
  setup: 'ソラナバリデーターをセットアップ',
  epoch: '現在のエポックを表示',
  slot: '現在のスロットを表示',
  solv: 'Solvエンドロール AA を表示',
  installer: '以下からオプションを選択してください:',
}

export default cmdsJA
